import { Container } from '@flos/react-ui';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Preloading from './components/Preloading';
import Receipt from './components/Receipt';
import WriteToUs from './components/WriteToUs';
import { RECEIPT_PATH } from './constants';

const App = () => {
  return (
    <Router basename="/faa-hjaelp/kontakt-os/skriv-besked">
      <Routes>
        <Route
          path="/"
          element={
            <Preloading>
              <Container>
                <div className="u-Space-down">
                  <WriteToUs />
                </div>
              </Container>
            </Preloading>
          }
        />
        <Route
          path={`/${RECEIPT_PATH}`}
          element={
            <Container>
              <div className="u-Space-down">
                <Receipt />
              </div>
            </Container>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
